"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (function (virtual) { return function (_a) {
    var data = (_a === void 0 ? {} : _a).data;
    var msgId = virtual.msgId;
    return {
        action: 'devSend',
        msgId: msgId,
        params: {
            appTid: [],
            data: virtual.encode(__assign({}, data, { msgId: msgId })),
            devTid: virtual.device.devTid,
            subDevTid: virtual.subDevice.devTid || undefined
        }
    };
}; });



// WEBPACK FOOTER //
// ./src/actions/send/actions/devSend.ts